// src/i18n/LocaleSwitcher.tsx
import React from "react"
import { useTranslation } from "react-i18next"
import { supportedLngs } from "./config"

export default function LocaleSwitcher() {
  const { i18n } = useTranslation()

  return (
    <>
      <select
        className="rounded w-auto p-1"
        value={i18n.resolvedLanguage}
        onChange={(e) => i18n.changeLanguage(e.target.value)}
      >
        {Object.entries(supportedLngs).map(([code, name]) => (
          <option value={code} key={code}>
            {name}
          </option>
        ))}
      </select>
    </>
  )
}
